import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { SearchRoundsModelImpl } from './models/impls/search-rounds-model';
import { PatentsModel, SearchRoundsModel } from './types';
import { PatentsModelImpl } from './models/impls/patents-model';
import { FtoProApi } from './apis/fto-pro-api';
import { FtoProApiServiceImpl } from './apis/impls/fto-pro-api-service';
import { SearchRoundsServiceImpl } from './services/impls/search-rounds-service';
import { SearchRoundsService } from './services/search-rounds-service';
import { FtoSearchDirectorServiceImpl } from './services/impls/fto-search-director-service';
import { PatentsServiceImpl } from './services/impls/patents-service';
import { PatentsService } from './services/patents-service';
import { FtoSearchDirectorService } from './services/fto-search-director-service';
import { PatentCacheServiceImpl } from './services/impls/patent-cache-service';
import { PatentCacheService } from './services/patent-cache-service';
import { PatentSelectionServiceImpl } from './services/impls/patent-selection-service';
import { PatentSelectionService } from './services/patent-selection-service';
import { QuerySaveServiceImpl } from './services/impls/query-save-service';
import { QuerySaveService } from './services/query-save-service';
import { CommandContribution } from '@patsnap/tahiti-core';
import { FtoProCommandContribution } from './services/impls/command-contribution';

export function ftoProModule(bind: interfaces.Bind) {

    // 绑定 API 接口到实现 - 使用动态值绑定避免异步依赖问题
    bind(FtoProApiServiceImpl).toSelf().inSingletonScope();

    bind(FtoProApi).toDynamicValue(context => context.container.get(FtoProApiServiceImpl));

    bind(PatentsModel).to(PatentsModelImpl);
    bind(SearchRoundsModel).to(SearchRoundsModelImpl);
    bind(FtoSearchDirectorService).to(FtoSearchDirectorServiceImpl);
    bind(SearchRoundsService).to(SearchRoundsServiceImpl);
    bind(PatentsService).to(PatentsServiceImpl);
    bind(PatentCacheService).to(PatentCacheServiceImpl);
    bind(PatentSelectionService).to(PatentSelectionServiceImpl);
    bind(QuerySaveService).to(QuerySaveServiceImpl);

    bind(CommandContribution).to(FtoProCommandContribution);
}
